"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _Spinner = _interopRequireDefault(require("../common/Spinner"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// Collapsed preview height before the "Show more" toggle appears.
var COLLAPSED_MAX_PX = 96;
var ClauseRow = function ClauseRow(_ref) {
  var _clause$access$isOwne, _clause$access, _clause$access$canMan, _clause$access2, _clause$sharing, _clause$sharing2, _clause$tags;
  var clause = _ref.clause,
    isSelected = _ref.isSelected,
    onSelectClause = _ref.onSelectClause,
    onOpenClause = _ref.onOpenClause,
    onShareClause = _ref.onShareClause,
    onDeleteClause = _ref.onDeleteClause;
  var isOwner = (_clause$access$isOwne = (_clause$access = clause.access) === null || _clause$access === void 0 ? void 0 : _clause$access.isOwner) !== null && _clause$access$isOwne !== void 0 ? _clause$access$isOwne : false;
  var canManageShares = (_clause$access$canMan = (_clause$access2 = clause.access) === null || _clause$access2 === void 0 ? void 0 : _clause$access2.canManageShares) !== null && _clause$access$canMan !== void 0 ? _clause$access$canMan : false;
  var isShared = !isOwner || ((_clause$sharing = clause.sharing) === null || _clause$sharing === void 0 ? void 0 : _clause$sharing.hasAnyShares) === true;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    overflowing = _useState4[0],
    setOverflowing = _useState4[1];
  var previewRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var el = previewRef.current;
    if (!el) return;
    var update = function update() {
      return setOverflowing(el.scrollHeight > COLLAPSED_MAX_PX + 4);
    };
    update();
    if (typeof ResizeObserver === "undefined") return;
    var observer = new ResizeObserver(update);
    observer.observe(el);
    return function () {
      return observer.disconnect();
    };
  }, [clause.contentText]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    role: "button",
    tabIndex: 0,
    onClick: function onClick() {
      return onSelectClause(clause);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onSelectClause(clause);
      }
    },
    className: "group flex flex-col items-start px-2 py-2 gap-1 rounded-lg border transition-colors cursor-pointer ".concat(isSelected ? "bg-background-primary-canvas border-primary" : "border-transparent hover:bg-background-primary-canvas"),
    "data-sentry-component": "ClauseRow",
    "data-sentry-source-file": "ClausesTab.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex flex-row items-start gap-2 w-full",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col items-start flex-1 min-w-0",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ref: previewRef,
          className: "w-full overflow-hidden",
          style: expanded ? undefined : {
            maxHeight: COLLAPSED_MAX_PX
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: "m-0 text-[13px] leading-normal text-[#212528] whitespace-pre-wrap break-words",
            children: clause.contentText
          })
        }), overflowing && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          type: "button",
          className: "mt-1 bg-transparent border-none cursor-pointer p-0 text-[11px] font-medium text-primary hover:underline",
          onClick: function onClick(e) {
            e.stopPropagation();
            setExpanded(function (v) {
              return !v;
            });
          },
          children: expanded ? "Show less" : "Show more"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-row justify-end items-center gap-1 flex-shrink-0",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "hidden group-hover:flex group-focus-within:flex items-center gap-1",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            type: "button",
            title: "Edit",
            className: "flex items-center justify-center w-7 h-7 rounded bg-transparent border-none cursor-pointer hover:bg-background-primary-canvas",
            onClick: function onClick(e) {
              e.stopPropagation();
              onOpenClause(clause);
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.EditIcon, {
              width: 15,
              height: 15,
              className: "text-[#6B7280]",
              "data-sentry-element": "EditIcon",
              "data-sentry-source-file": "ClausesTab.tsx"
            })
          }), canManageShares && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            type: "button",
            title: "Share",
            className: "flex items-center justify-center w-7 h-7 rounded bg-transparent border-none cursor-pointer hover:bg-background-primary-canvas",
            onClick: function onClick(e) {
              e.stopPropagation();
              onShareClause(clause, e.currentTarget);
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ShareIcon, {
              width: 15,
              height: 15,
              className: (_clause$sharing2 = clause.sharing) !== null && _clause$sharing2 !== void 0 && _clause$sharing2.hasAnyShares ? "text-primary" : "text-[#6B7280]"
            })
          }), isOwner && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            type: "button",
            title: "Delete",
            className: "flex items-center justify-center w-7 h-7 rounded bg-transparent border-none cursor-pointer hover:bg-[#FEE4E2]",
            onClick: function onClick(e) {
              e.stopPropagation();
              onDeleteClause(clause.id);
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.DeleteIcon, {
              width: 15,
              height: 15,
              className: "text-[#6B7280]"
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "flex-shrink-0 group-hover:hidden group-focus-within:hidden",
          title: isShared ? "Shared" : "Private to you",
          children: isShared ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.GroupIcon, {
            width: 16,
            height: 16,
            className: "text-[#6B7280]"
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.PersonIcon, {
            width: 16,
            height: 16,
            className: "text-[#6B7280]"
          })
        })]
      })]
    }), (clause.tags && clause.tags.length > 0 || clause.similarityScore != null) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex items-center flex-wrap gap-1 text-xs text-[#686766] w-full",
      children: [(_clause$tags = clause.tags) === null || _clause$tags === void 0 ? void 0 : _clause$tags.map(function (tag) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "inline-flex items-center px-2 py-0.5 rounded-full bg-background-primary-canvas text-primary text-[11px]",
          children: tag
        }, tag);
      }), clause.similarityScore != null && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "inline-flex items-center px-2 py-0.5 rounded-full bg-[#E7F5EC] text-[#1F7A40] text-[11px] ml-auto",
        children: [Math.round(clause.similarityScore * 100), "% match"]
      })]
    })]
  });
};
var ClausesTab = function ClausesTab(_ref2) {
  var clauses = _ref2.clauses,
    isLoading = _ref2.isLoading,
    currentPage = _ref2.currentPage,
    totalClauses = _ref2.totalClauses,
    itemsPerPage = _ref2.itemsPerPage,
    selectedClauseId = _ref2.selectedClauseId,
    onSelectClause = _ref2.onSelectClause,
    onOpenClause = _ref2.onOpenClause,
    onShareClause = _ref2.onShareClause,
    onDeleteClause = _ref2.onDeleteClause,
    onPageChange = _ref2.onPageChange;
  var hasMorePages = totalClauses !== null && totalClauses > (currentPage + 1) * itemsPerPage;
  if (isLoading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex items-center justify-center h-32",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Spinner.default, {
        size: 24
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-px",
    "data-sentry-component": "ClausesTab",
    "data-sentry-source-file": "ClausesTab.tsx",
    children: [clauses.map(function (clause) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(ClauseRow, {
        clause: clause,
        isSelected: selectedClauseId === clause.id,
        onSelectClause: onSelectClause,
        onOpenClause: onOpenClause,
        onShareClause: onShareClause,
        onDeleteClause: onDeleteClause
      }, clause.id);
    }), clauses.length === 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "text-center py-8 text-[#686766] text-[13px]",
      children: "No clauses found"
    }), clauses.length > 0 && totalClauses !== null && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex items-center justify-center gap-1 my-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: function onClick() {
          if (currentPage > 0) {
            onPageChange(currentPage - 1);
          }
        },
        disabled: currentPage === 0,
        "aria-label": "Previous page",
        className: "p-1",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronLeftIcon, {
          width: 18,
          height: 18,
          fill: currentPage > 0 ? "darkgrey" : "lightgrey"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "text-xs text-[#686766]",
        children: [currentPage * itemsPerPage + 1, " - ", currentPage * itemsPerPage + clauses.length, " of ", totalClauses]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: function onClick() {
          if (hasMorePages) {
            onPageChange(currentPage + 1);
          }
        },
        disabled: !hasMorePages,
        "aria-label": "Next page",
        className: "p-1",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {
          width: 18,
          height: 18,
          fill: hasMorePages ? "darkgrey" : "lightgrey"
        })
      })]
    }), clauses.length > 0 && !hasMorePages && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "text-center py-2 text-[#686766] text-[13px]",
      children: "End of list"
    })]
  });
};
var _default = exports.default = ClausesTab;